import React from 'react';
import ReactGridLayout from 'react-grid-layout';
import { useParams } from 'react-router-dom';
import RenderViewFromTemplate from 'src/components/RenderViewFromTemplate';
import {
	useGetCustomDashboardByIdQuery,
	useGetCustomDashboardObserversQuery,
	useGetObserversQuery,
	useLazyGetLastOcurrenceByObserverIdQuery
} from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import * as C from 'src/pages/indicators/ViewIndicatorPage/styles';
import { Flex } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import NotAuthorized from 'src/pages/httpStatuses/NotAuthorized';
import { IDashboardTree } from 'src/pages/indicators/EditIndicatorPage/types/dashboardTree';

export default function ViewIndicatorPage() {
	const dashboard_id = useParams()?.dashboard_id ?? '';
	const { data: observersData, } =
        useGetObserversQuery();
	const {
		data: dashboardData,
		isLoading: isLoadingDashboardData,
		isError: isErrorDashboardData,
	} = useGetCustomDashboardByIdQuery({
		dashboard_id,
	});
	const { data: customDashboardObserversData, } =
        useGetCustomDashboardObserversQuery({ dashboard_id, });

	const customDashboardObservers = React.useMemo(() => {
		const customDashboardObserversIds =
            customDashboardObserversData?.map((i) => i.observer_id) ?? [];
		return (
			observersData?.filter((observer) =>
				customDashboardObserversIds.includes(observer.observer_id)
			) ?? []
		);
	}, [ observersData, customDashboardObserversData, ]);
	const [ getLastOcurrence, ] =
        useLazyGetLastOcurrenceByObserverIdQuery();

	const [ dashboardTree, setDashboardTree, ] = React.useState<IDashboardTree>(
		{}
	);

	const [ time, setTime, ] = React.useState(0);

	React.useEffect(() => {
		const timer = setTimeout(() => {
			setTime(time + 1);
		}, 10000);
		return () => {
			clearTimeout(timer);
		};
	}, [ time, ]);

    

	React.useEffect(() => {
		if (customDashboardObservers) {
			Promise.all(
				customDashboardObservers?.map(async (observer) => {
					const observerNameAsVariable = observer.short_name
						?.replace(/ /g, '_')
						.toLowerCase();

					await getLastOcurrence({
						observer_id: observer.observer_id,
					})
						.unwrap()
						.then((res) => {
							setDashboardTree((prev) => ({
								...prev,
								[observerNameAsVariable]: {
									...res.ocurrence_data,
								},
							}));
						})
						.catch(() => {return;});
				})
			);
		}
	}, [ time, ]);
    
	return (
		<DashboardTemplate contentOnly totallyColapseSidebar>
			{!!dashboardData &&
                typeof dashboardData?.layout != 'string' &&
                !isLoadingDashboardData &&
                !isErrorDashboardData && (
				<ReactGridLayout
					className='layout'
					layout={dashboardData?.layout?.map((item) => {
						return {
							...item,
							x: item.x,
							y: item.y,
							w: item.w,
							h: item.h,
							isDraggable: false,
							isResizable: false,
						};
					})}
					cols={30}
					rowHeight={30}
					margin={[ 0, 0, ]}
					width={window.innerWidth}
				>
					{dashboardData?.layout?.map((item) => (
						<C.Widget
							style={{
								boxShadow:
                                        ' 10px 10px 30px -10px rgba(191,191,191,.7)',
								border: '1px solid rgba(0,0,0,.1)',
								borderRadius: '5px',
							}}
							key={item.i}
						>
							{dashboardTree && (
								<RenderViewFromTemplate
									templateProxy={item.template}
									viewProxy={dashboardTree}
								/>
							)}
						</C.Widget>
					))}
				</ReactGridLayout>
			)}
			{isLoadingDashboardData || time < 1 && (
				<Flex
					style={{
						width: '100%',
						height: '100%',
					}}
					align='center'
					justify='center'
				>
					<LoadingOutlined style={{ fontSize: '40px', }} />
				</Flex>
			)}
			{isErrorDashboardData && <NotAuthorized />}
		</DashboardTemplate>
	);
}
